export const translations = {
  RU: {
    brand: { name: 'MaximGun', descriptor: 'цифровой архив' },
    nav: {
      search: 'Каталог',
      gallery: 'Галерея',
      serial: 'Поиск по номеру',
      articles: 'Статьи',
      identify: 'Определитель станка',
      add: 'Добавить',
      moderation: 'Модерация',
      about: 'О проекте',
    },
    common: {
      menu: 'Меню',
      close: 'Закрыть',
      back: 'Назад',
      loading: 'Загрузка…',
      retry: 'Попробовать снова',
      viewAll: 'Смотреть всё',
      learnMore: 'Подробнее',
      error: 'Не удалось загрузить данные',
      empty: 'Здесь пока ничего нет',
    },
    preferences: {
      title: 'Вид сайта',
      theme: 'Тема',
      language: 'Язык',
      light: 'Светлая',
      dark: 'Тёмная',
      system: 'Как в системе',
      russian: 'Русский',
      english: 'English',
    },
    auth: {
      signIn: 'Войти',
      signOut: 'Выйти',
      title: 'Вход в архив',
      unavailable: 'Вход и регистрация на данный момент не работают. Просмотр архива доступен без аккаунта.',
      registerTitle: 'Регистрация',
      resetTitle: 'Восстановление пароля',
      username: 'Логин или email',
      newUsername: 'Логин',
      password: 'Пароль',
      email: 'Email',
      submit: 'Войти',
      createAccount: 'Создать аккаунт',
      forgot: 'Забыли пароль?',
      noAccount: 'Нет аккаунта?',
      hasAccount: 'Уже есть аккаунт?',
      send: 'Отправить ссылку',
      cancel: 'Отмена',
      agreement: 'Я принимаю Пользовательское соглашение',
      privacy: 'Я ознакомлен с Политикой обработки персональных данных',
      consent: 'Я даю согласие на обработку персональных данных',
      details: 'Открыть документ',
      required: 'Для регистрации необходимо отметить все три пункта.',
      invalid: 'Неверный логин или пароль.',
      failed: 'Не удалось войти. Попробуйте позже.',
      notConfirmed: 'Аккаунт не подтверждён. Письмо можно отправить повторно.',
      resend: 'Отправить письмо повторно',
      registerSuccess: 'Проверьте почту для подтверждения аккаунта.',
      resetSuccess: 'Ссылка для сброса пароля отправлена на почту.',
    },
    home: {
      kicker: 'Некоммерческий исследовательский проект',
      title: 'Архив пулемётов системы Максима',
      intro: 'Пулемёты, станки, детали и ЗиП.',
      searchPlaceholder: 'Номер, производитель, деталь или описание',
      searchAction: 'Найти в архиве',
      browse: 'Открыть каталог',
      usefulLinks: 'Полезные ссылки',
      sectionsTitle: 'Работа с архивом',
      sectionsIntro: 'Основные способы найти и сопоставить сведения.',
      serialTitle: 'Определить год по номеру',
      serialText: 'Сопоставление серийного номера с известными экземплярами и производственными периодами.',
      galleryTitle: 'Просмотреть фотографии',
      galleryText: 'Снимки маркировок, деталей и комплектных образцов с привязкой к карточкам.',
      manufacturersTitle: 'Производители',
      modificationsTitle: 'Основные модификации',
      articlesTitle: 'Читать исследования',
      articlesText: 'Наблюдения, музейные находки и материалы по эволюции конструкции.',
      identifierTitle: 'Особенности царского станка Соколова по годам',
      identifierText: 'Пошаговый определитель по крупным конструктивным признакам.',
      newTitle: 'Последние пополнения',
      newIntro: 'Недавно добавленные экземпляры и детали.',
      archiveNote: 'Архив создаётся на основе музейных предметов, частных коллекций, исторических источников и наблюдений участников проекта.',
    },
    legal: { title: 'Правовая информация', openPage: 'Открыть отдельной страницей' },
    footer: {
      note: 'Некоммерческий историко-справочный проект о пулемётах системы Максима, станках, деталях и отдельных экземплярах.',
      disclaimer: 'Сайт не является магазином, торговой площадкой или экспертной организацией.',
      agreement: 'Соглашение',
      privacy: 'Персональные данные',
      consent: 'Согласие',
      cookies: 'Cookies',
      friends: 'Друзья проекта',
      legacy: 'Старая версия сайта',
      top: 'Наверх',
    },
  },
  EN: {
    brand: { name: 'MaximGun', descriptor: 'digital archive' },
    nav: {
      search: 'Catalogue',
      gallery: 'Gallery',
      serial: 'Serial number search',
      articles: 'Articles',
      identify: 'Mount identifier',
      add: 'Contribute',
      moderation: 'Moderation',
      about: 'About',
    },
    common: {
      menu: 'Menu',
      close: 'Close',
      back: 'Back',
      loading: 'Loading…',
      retry: 'Try again',
      viewAll: 'View all',
      learnMore: 'Learn more',
      error: 'Unable to load data',
      empty: 'Nothing here yet',
    },
    preferences: {
      title: 'Display',
      theme: 'Theme',
      language: 'Language',
      light: 'Light',
      dark: 'Dark',
      system: 'Use system setting',
      russian: 'Русский',
      english: 'English',
    },
    auth: {
      signIn: 'Sign in',
      signOut: 'Sign out',
      title: 'Sign in to the archive',
      unavailable: 'Sign-in and registration are currently unavailable. You can browse the archive without an account.',
      registerTitle: 'Create an account',
      resetTitle: 'Reset password',
      username: 'Username or email',
      newUsername: 'Username',
      password: 'Password',
      email: 'Email',
      submit: 'Sign in',
      createAccount: 'Create account',
      forgot: 'Forgot password?',
      noAccount: 'No account yet?',
      hasAccount: 'Already registered?',
      send: 'Send reset link',
      cancel: 'Cancel',
      agreement: 'I accept the User Agreement',
      privacy: 'I have read the Personal Data Policy',
      consent: 'I consent to personal data processing',
      details: 'Open document',
      required: 'Please accept all three items to register.',
      invalid: 'Incorrect username or password.',
      failed: 'Unable to sign in. Please try again later.',
      notConfirmed: 'The account is not confirmed. You can resend the email.',
      resend: 'Resend confirmation email',
      registerSuccess: 'Check your inbox to confirm the account.',
      resetSuccess: 'A password reset link has been sent to your email.',
    },
    home: {
      kicker: 'Independent non-commercial research project',
      title: 'Archive of Maxim-system machine guns',
      intro: 'Machine guns, mounts, parts and spares.',
      searchPlaceholder: 'Serial number, maker, part or description',
      searchAction: 'Search the archive',
      browse: 'Browse catalogue',
      usefulLinks: 'Useful links',
      sectionsTitle: 'Explore the archive',
      sectionsIntro: 'The main ways to find and compare records.',
      serialTitle: 'Estimate a year by serial number',
      serialText: 'Compare a serial number with documented examples and known production periods.',
      galleryTitle: 'Browse photographs',
      galleryText: 'Markings, parts and complete examples linked to their catalogue records.',
      manufacturersTitle: 'Manufacturers',
      modificationsTitle: 'Main variants',
      articlesTitle: 'Read the research',
      articlesText: 'Field notes, museum finds and studies of construction changes.',
      identifierTitle: 'Imperial-era Sokolov mount features by year',
      identifierText: 'A guided identifier based on major construction features.',
      newTitle: 'Recent additions',
      newIntro: 'Recently added examples and parts.',
      archiveNote: 'The archive is compiled from museum objects, private collections, historical sources and observations contributed by participants.',
    },
    legal: { title: 'Legal information', openPage: 'Open document page' },
    footer: {
      note: 'A non-commercial historical reference project about Maxim guns, mounts, parts and surviving examples.',
      disclaimer: 'This website is not a shop, marketplace or appraisal service.',
      agreement: 'Agreement',
      privacy: 'Personal data',
      consent: 'Consent',
      cookies: 'Cookies',
      friends: 'Friends of the project',
      legacy: 'Previous site version',
      top: 'Back to top',
    },
  },
};
